var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.618 36.3896C29.2851 37.339 20.7329 31.3209 19.0949 31.3077C17.457 31.2946 8.80848 37.1742 7.49117 36.2035C6.17386 35.2328 9.27079 25.2626 8.77726 23.7052C8.28372 22.1479 0.00329521 15.7628 0.521987 14.2135C1.04079 12.6643 11.507 12.5204 12.8399 11.571C14.1728 10.6217 17.7038 0.795982 19.3418 0.809095C20.9797 0.822322 24.3512 10.7036 25.6685 11.6743C26.9858 12.6449 37.4485 12.9573 37.9421 14.5147C38.4357 16.072 30.0531 22.323 29.5343 23.8722C29.0156 25.4215 31.9509 35.4402 30.618 36.3896Z",
    fill: "#F7B01A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a51c2142b93b931efc09c30944a75f0a.svg";
export { ForwardRef as ReactComponent };